import styles from '../../styles.module.scss';
import { useRedeemCouponContext, VARIANTS } from '../context';

import Card from '~components/Card';

import containerStyles from './styles.module.scss';

export function Container({ children }) {
  const { variant } = useRedeemCouponContext();

  if (variant === VARIANTS.small) {
    return <div className={containerStyles.container}>{children}</div>;
  }

  return (
    <Card overrideClasses className={styles.card}>
      {children}
    </Card>
  );
}
